import { type Meta } from '../types/docs';

const META: Meta = {
  description: 'User clicked an action in the canvas node toolbar',
  name: 'canvas_node_toolbar_action_clicked',
  params: [
    {
      description: 'The id of the canvas',
      name: 'canvas_id',
      required: true,
      type: 'string',
    },
    {
      description: 'The type of node the toolbar action was performed on',
      name: 'node_type',
      required: true,
      type: 'enum',
      values: ['image', 'video'],
    },
    {
      description: 'The toolbar action that was clicked',
      name: 'action_taken',
      required: true,
      type: 'enum',
      values: [
        'adjust_image',
        'camera_angle',
        'change_lighting',
        'smart_resize',
        'crop',
        'prompt',
        'flip_and_rotate',
        'erase',
        'extend_background',
        'remove_background',
        'upscale',
        'convert_to_gif',
      ],
    },
  ],
};

export default META;
